import { EntityName } from '../auth/Security';
import { SIDE_PANEL_IDS } from '../constants/constants';
import { ENTITY_CONSTANTS } from '../constants/entityConstants';

// Only activated for local builds even if set to `true`.
export const ENABLE_DEEP_LINK_DEBUG = false && process.env.NODE_ENV === 'development';

export const DEEP_LINK_UI_QUERY_PARAM_KEY = 'ui';
export const DEEP_LINK_APP_NAME_PARAM_KEY = 'appName';
export const DEEP_LINK_RESOLVER_ROUTE_PATH = '/:appId/deeplink';

export const DEEP_LINK_ORG_ID_QUERY_PARAM_KEY = 'orgId';

// Keep this list intentionally small; expand only when a query param is required for deep-link replay.
export const DEEP_LINK_ALLOWED_QUERY_PARAMS: string[] = ['orgId'];

export const LINKED_ENTITY_NODE_KEYS = ['note', 'attachment'];

export const LINKED_ENTITY_NODE_KEY_TO_SIDE_PANEL_ID_MAP: Record<string, string> = {
    note: SIDE_PANEL_IDS.notes,
    attachment: SIDE_PANEL_IDS.attachments
};

export const SIDE_PANEL_ID_TO_LINKED_ENTITY_NODE_KEY_MAP: Record<string, string> = Object.entries(
    LINKED_ENTITY_NODE_KEY_TO_SIDE_PANEL_ID_MAP
).reduce(
    (acc, [nodeKey, panelId]) => {
        acc[panelId] = nodeKey;
        return acc;
    },
    {} as Record<string, string>
);

export const ADDITIONAL_ENTITY_FIELDS_FOR_DEEP_LINK_UI_STATE: Partial<Record<EntityName, string[]>> = {
    [ENTITY_CONSTANTS.production]: ['managedProduction', 'state'],
    [ENTITY_CONSTANTS.opportunity]: ['state']
};
